import type { User, Uuid } from '@beacon/core';

import { Avatar } from './avatar.js';
import { Dropdown } from '@/components/ui/dropdown.js';

export function AssigneeDropdown({
  value,
  users,
  loading,
  onChange,
}: {
  value: Uuid | null;
  users: User[];
  loading?: boolean;
  onChange: (next: Uuid | null) => void;
}) {
  const items = [
    {
      value: null as Uuid | null,
      label: <span className="text-[13px] text-ink-300">Unassigned</span>,
    },
    ...users.map((u) => ({
      value: u.id,
      label: (
        <span className="inline-flex items-center gap-2 text-[13px] text-ink-100">
          <Avatar name={u.name} size={20} />
          <span>{u.name}</span>
        </span>
      ),
      description: u.role === 'ops' ? 'ops' : 'staff',
    })),
  ];

  return (
    <Dropdown<Uuid | null>
      value={value}
      onChange={onChange}
      ariaLabel="Reassign ticket"
      items={items}
      renderTrigger={(item) => {
        if (loading) {
          return <span className="text-[13px] text-ink-300">Loading…</span>;
        }
        if (!item || item.value === null) {
          return (
            <span className="text-[13px] text-ink-300">Unassigned</span>
          );
        }
        const u = users.find((x) => x.id === item.value);
        if (!u) return <span className="text-[13px] text-ink-300">—</span>;
        return (
          <span className="inline-flex items-center gap-2 text-[13px] text-ink-100">
            <Avatar name={u.name} size={20} />
            <span className="truncate">{u.name}</span>
          </span>
        );
      }}
    />
  );
}
